export default __webpack_public_path__ + "static/media/offer.b224df15.png";